<template>
  <PButton
    :as="is_upload ? 'a' : 'button'"
    :disabled="is_disabled || null"
    :size="size"
    variant="outlined"
    @click.stop="submit"
  >
    <div v-if="icon_fontawesome">
      <FontAwesomeIcon
        :icon="icon_fontawesome"
        :spin="icon_fontawesome === 'spinner'"
      />
    </div>
    <div
      v-if="$slots.default && !hide_text"
      class="font-semibold"
    >
      <slot />
    </div>
  </PButton>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { BUTTON_SECONDARY_ACTIONS_TO_FONTAWESOME_ICON } from '@/app/data/button_constants';

const props = defineProps({
  is_disabled: { type: Boolean },
  action: {
    type: String,
    default: null,
    validator: (prop) => Object.keys(BUTTON_SECONDARY_ACTIONS_TO_FONTAWESOME_ICON).includes(prop),
  },
  to: { type: Object, default: null },
  is_upload: { type: Boolean },
  size: { type: String, default: 'small' },
  hide_text: { type: Boolean },
});

const emit = defineEmits(['onClick']);

const router = useRouter();

const icon_fontawesome = computed(() => BUTTON_SECONDARY_ACTIONS_TO_FONTAWESOME_ICON[props.action]);

function submit(event) {
  if (props.is_disabled) return null;
  if (props.to) return router.push(props.to);
  emit('onClick', event);
  return null;
}
</script>
